import { render } from "./MenuVoteComment.vue?vue&type=template&id=00fca4e2&scoped=true"
import script from "./MenuVoteComment.vue?vue&type=script&lang=js"
export * from "./MenuVoteComment.vue?vue&type=script&lang=js"

import "./MenuVoteComment.vue?vue&type=style&index=0&id=00fca4e2&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fca4e2"]])

export default __exports__